import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const SearchBar = ({ onSearch, onSortChange, sortBy }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isAdvancedOpen, setIsAdvancedOpen] = useState(false);

  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'popular', label: 'Most Popular' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'downloads', label: 'Most Downloaded' }
  ];

  const handleSearch = (e) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    // Real-time search with debouncing would be implemented here
    if (value.length > 2 || value.length === 0) {
      onSearch(value);
    }
  };

  const quickSearchTerms = [
    'GCC Setup Guide',
    'Talent Acquisition',
    'Compliance Requirements',
    'Cost Optimization',
    'Technology Integration',
    'Operational Excellence'
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 mb-8">
      <form onSubmit={handleSearch} className="space-y-4">
        <div className="flex flex-col lg:flex-row gap-4">
          <div className="flex-1 relative">
            <Input
              type="search"
              placeholder="Search resources, guides, reports..."
              value={searchTerm}
              onChange={handleInputChange}
              className="pl-12"
            />
            <Icon 
              name="Search" 
              size={20} 
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-text-secondary"
            />
          </div>
          
          <div className="flex items-center space-x-4">
            <select
              value={sortBy}
              onChange={(e) => onSortChange(e.target.value)}
              className="px-4 py-2 border border-border rounded-lg bg-background text-text-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            
            <button
              type="button"
              onClick={() => setIsAdvancedOpen(!isAdvancedOpen)}
              className="px-4 py-2 border border-border rounded-lg hover:bg-muted transition-colors duration-300 flex items-center"
            >
              <Icon name="Settings" size={16} className="mr-2" />
              Advanced
            </button>
          </div>
        </div>

        {/* Quick Search Terms */}
        <div className="flex flex-wrap gap-2">
          <span className="text-sm text-text-secondary">Quick searches:</span>
          {quickSearchTerms.map((term, index) => (
            <button
              key={index}
              type="button"
              onClick={() => {
                setSearchTerm(term);
                onSearch(term);
              }}
              className="px-3 py-1 text-sm bg-muted hover:bg-primary hover:text-primary-foreground rounded-full transition-colors duration-300"
            >
              {term}
            </button>
          ))}
        </div>

        {/* Advanced Search Options */}
        {isAdvancedOpen && (
          <div className="border-t border-border pt-4 mt-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Input
                label="Author"
                placeholder="Search by author name"
                className="text-sm"
              />
              <Input
                label="Date Range"
                type="date"
                className="text-sm"
              />
              <Input
                label="Minimum Rating"
                type="number"
                min="1"
                max="5"
                placeholder="1-5 stars"
                className="text-sm"
              />
            </div>
          </div>
        )}
      </form>

      {/* Search Stats */}
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-border text-sm text-text-secondary">
        <div>
          Showing 127 resources
        </div>
        <div className="flex items-center space-x-4">
          <button className="flex items-center hover:text-primary transition-colors duration-300">
            <Icon name="Grid" size={16} className="mr-1" />
            Grid View
          </button>
          <button className="flex items-center hover:text-primary transition-colors duration-300">
            <Icon name="List" size={16} className="mr-1" />
            List View
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;